import $ from 'jquery';
import 'jquery.dotdotdot/src/jquery.dotdotdot.js';
import 'bootstrap/js/dist/collapse.js';
import 'bootstrap/js/dist/modal.js';
import 'bootstrap/js/dist/tab.js';
import {isIE, isTouchDevice} from './utilities/user-agent.mjs';
import throttle from 'lodash/throttle.js';
import Aside from './ui/Aside.mjs';
import Footer from './ui/Footer.mjs';
import Form from './ui/Form.mjs';
import Header from './ui/Header.mjs';
import OffCanvas from './ui/OffCanvas.mjs';

export default class Ui {
  constructor() {
    this.$window = $(window);
    this.$body = $('body');
    initHelperClasses.call(this);
    this.Header = new Header(this);
    this.Footer = new Footer();
    this.Form = new Form(this);
    this.OffCanvas = OffCanvas;
    this.Aside = Aside;

    initVideoLazyLoad();
    initToTopButton.call(this);
    initSmoothAnchorScrolling.call(this);
    initTrippleDots.call(this);
  }
}

/**
 * Copy from ui/ui.js
 */
function initHelperClasses() {
  if (isIE) {
    this.$body.addClass('is-IE');
  }

  this.$body.addClass(() => {
    return isTouchDevice ? 'isTouch' : 'noTouch';
  });
}

function initVideoLazyLoad() {
  const $lazyVideos = $('video.lazy');

  if ($lazyVideos.length && 'IntersectionObserver' in window) {
    const lazyVideoObserver = new IntersectionObserver((entries, observer) => {
        entries.forEach(function(video) {
          if (video.isIntersecting) {
            for (const source in video.target.children) {
              const videoSource = video.target.children[source];
              if (typeof videoSource.tagName === 'string' &&
                videoSource.tagName === 'SOURCE') {
                videoSource.src = videoSource.dataset.src;
              }
            }

            video.target.load();
            video.target.classList.remove('lazy');
            lazyVideoObserver.unobserve(video.target);
          }
        });
      }, {
      rootMargin: '100px 0px',
      threshold: 0.01
    });

    $lazyVideos.each((index, lazyVideo) => {
      lazyVideoObserver.observe(lazyVideo);
    });
  }
}

/**
 * Copy from ui/ui.js
 */
function initToTopButton() {
  const $button = $('#btn-to-top');
  let lastPixelScrolled = 0;

  this.$window.on('scroll.Ui.toTopButton', throttle(
    () => {
      const pixelScrolled = this.$window.scrollTop();
      if (pixelScrolled <= lastPixelScrolled) {
        $button.show();
      } else {
        $button.hide();
      }
      lastPixelScrolled = pixelScrolled;
    },
    125,
  ));

  $button.on('click', function() {
    $('html, body').animate({
      scrollTop: 0,
    }, 1000);
    return false;
  });
}

/**
 * Copy from ui/ui.js
 */
function initSmoothAnchorScrolling() {
  $('a[href*="#"]:not([href="#"]):not([data-toggle="tab"])').click(function() {
    if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
      var target = $(this.hash);
      target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
      if (target.length) {
        $('html, body').animate({
          scrollTop: target.offset().top - 70,
        }, 1000, 'swing');
        return false;
      }
    }
  });
}

/**
 * Copy from ui/ui.js->trippleDots()
 */
function initTrippleDots() {
  $('.teaser-highlight-product-copytext').dotdotdot({
    ellipsis: ' ...',
    watch: true,
  });
}
